import $ from 'jquery';
import {is_function} from '../../../../Helpers/js';

$.widget('lp.capslockDetector', {
  form: null,
  inputfield: null,

  _create: function () {
    window.Glossar.add({
      CAPSLOCK_ON: {de: 'Feststelltaste aktiviert', en: 'Caps Lock is On'},
    });

    this.form = $(this.element).closest('form');
    this.inputfield = $(this.element).closest('.field');
    this.label = $('<div>').addClass('ui pointing basic icon label capslockdetect');
    this.label
      .append($('<i>').addClass('exclamation triangle orange icon'))
      .append(' ' + window.Glossar.getText('CAPSLOCK_ON'))
      .hide();
    this.inputfield.append(this.label);
    this.onload();
  },

  onload: function () {
    var that = this,
      capsLockEnabled = null;

    var $pwfield = $(this.element);

    $pwfield.on('keyup', function () {
      if (capsLockEnabled) {
        that.label.show();
      } else {
        that.label.hide();
      }
    });
    $pwfield.on('focus', function () {
      if (capsLockEnabled) {
        that.label.show();
      } else {
        that.label.hide();
      }
    });
    $pwfield.on('blur', function () {
      that.label.hide();
    });

    var onkeydown = document.onkeydown;
    document.onkeydown = function (e) {
      e = e || event;
      if (e.keyCode === 20 && capsLockEnabled !== null) {
        capsLockEnabled = !capsLockEnabled;
      }

      if (is_function(onkeydown)) onkeydown(e);
    };

    var onkeypress = document.onkeypress;
    document.onkeypress = function (e) {
      e = e || event;
      var chr = that.getChar.call(that, e);
      if (!chr) return; // special key

      if (chr.toLowerCase() === chr.toUpperCase()) {
        // caseless symbol, like whitespace
        // can't use it to detect Caps Lock
        return;
      }

      capsLockEnabled = (chr.toLowerCase() === chr && e.shiftKey) || (chr.toUpperCase() === chr && !e.shiftKey);

      if (is_function(onkeypress)) onkeypress(e);
    };
  },

  getChar: function (e) {
    if (e.which == null) {
      return String.fromCharCode(e.keyCode); // IE
    }
    if (e.which !== 0 && e.charCode !== 0) {
      return String.fromCharCode(e.which); // rest
    }
    return null;
  },
});

$.initialize('[data-plugin~="capslock-detector"]', function () {
  $(this).capslockDetector();
});
